import {MinimumGamblingAgeIconDefaultBox} from "./minimum-gambling-age-icon.default.box";
import styled from "styled-components";

export const MinimumGamblingAgeIconSiBox = styled(MinimumGamblingAgeIconDefaultBox)`
  height: 40px;
  width: 40px;
`